import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { api, formatErr } from "@/lib/api";

const T = {
  en: { h: "Cancel your workshop seat?", p: "Your seat will go to the next person on the waitlist.", btn: "Yes, cancel my seat", done: "Your seat has been cancelled. Thank you for letting us know!", bad: "This cancel link isn't valid." },
  es: { h: "¿Cancelar su lugar en el taller?", p: "Su lugar será para la siguiente persona en la lista de espera.", btn: "Sí, cancelar mi lugar", done: "Su lugar fue cancelado. ¡Gracias por avisarnos!", bad: "Este enlace de cancelación no es válido." },
};

export default function WorkshopCancel() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const [w, setW] = useState(null);
  const [state, setState] = useState("ask");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get(`/public/workshops/${id}`).then((r) => setW(r.data)).catch(() => setState("bad")); }, [id]);
  const L = T[w?.lang || "en"];
  const cancel = async () => {
    setBusy(true);
    try { await api.post(`/public/workshops/${id}/cancel`, { token: params.get("t") || "" }); setState("done"); }
    catch (e) { setState(e.response?.status === 404 || e.response?.status === 422 ? "bad" : "ask"); if (e.response?.status >= 500) alert(formatErr(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50" data-testid="workshop-cancel-page">
      <header className="bg-white border-b border-slate-200"><div className="max-w-xl mx-auto px-4 py-4"><Brand /></div></header>
      <main className="max-w-xl mx-auto px-4 py-10">
        <div className="bg-white border border-slate-200 rounded-xl p-6 sm:p-8">
          {state === "bad" && <p data-testid="workshop-cancel-bad">{L.bad}</p>}
          {state === "done" && <p className="flex items-start gap-2 text-emerald-800 font-semibold" data-testid="workshop-cancel-done"><CheckCircle2 className="h-5 w-5 shrink-0" />{L.done}</p>}
          {state === "ask" && w && (
            <>
              <h1 className="font-display text-2xl sm:text-3xl font-extrabold text-slate-900">{L.h}</h1>
              <p className="mt-2 text-slate-600">{w.library} · {w.display_date}{w.time ? ` · ${w.time}` : ""}</p>
              <p className="mt-4 text-sm text-slate-600">{L.p}</p>
              <Button onClick={cancel} disabled={busy} className="mt-6 w-full h-12 bg-slate-900 hover:bg-slate-800" data-testid="workshop-cancel-confirm">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{L.btn}</Button>
            </>
          )}
        </div>
      </main>
    </div>
  );
}
